import React from 'react';
import { useTranslation } from 'react-i18next';
import EditorSaveStatus from 'components/EditorSaveStatus';
import TextLink from 'components/TextLink';
import Card from 'components/Card';
import StickyBox from 'components/StickyBox';
export function EditorPageStickySaveDiscardButton(_ref) {
  var hasChanges = _ref.hasChanges,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    isSaving = _ref.isSaving,
    tooltipTitle = _ref.tooltipTitle,
    buttonText = _ref.buttonText,
    cardVariant = _ref.cardVariant,
    onSave = _ref.onSave,
    onDiscard = _ref.onDiscard;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var tooltip = tooltipTitle || t('actions_resolve_errors_to_save');
  return /*#__PURE__*/React.createElement(StickyBox, {
    placement: "bottom",
    borderRadius: "large",
    mt: "m"
  }, /*#__PURE__*/React.createElement(Card, {
    px: "m",
    py: "s",
    variant: cardVariant
  }, /*#__PURE__*/React.createElement(EditorSaveStatus, {
    stateOptions: hasChanges && /*#__PURE__*/React.createElement(TextLink, {
      as: "button",
      onClick: onDiscard
    }, t('actions_discard')),
    hasUnsavedChanges: hasChanges,
    onSave: onSave,
    isDisabled: isDisabled,
    isSaving: isSaving,
    buttonText: buttonText,
    tooltipTitle: isDisabled ? tooltip : undefined,
    justifyContent: ['space-between', 'space-evenly'],
    breakpoints: "xxs"
  })));
}
export default EditorPageStickySaveDiscardButton;